import React, { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../HeroSection/HeroSection';
import ProductSelection from './ProductSelection/ProductSelection';
import FilterBar from './FilterAndTitleBar/FilterBar/FilterBar';

const EMPTY_FILTERS = { companies: [], filterCategories: [], originalCategories: [] };

function ProductsPage() {
  const location = useLocation();
  const [productCount, setProductCount] = useState(0);
  const [availableFilters, setAvailableFilters] = useState(EMPTY_FILTERS);
  const [activeFilters, setActiveFilters] = useState(EMPTY_FILTERS);
  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    setActiveFilters(EMPTY_FILTERS);
    setAvailableFilters(EMPTY_FILTERS);
    setAllProducts([]);
  }, [location.pathname]);

  const handleCountChange = useCallback((count) => {
    setProductCount(count);
  }, []);

  const handleFiltersAvailable = useCallback((filters) => {
    setAvailableFilters(filters);
  }, []);

  const handleFiltersChange = useCallback((filters) => {
    setActiveFilters(filters);
  }, []);

  const handleProductsLoaded = useCallback((products) => {
    setAllProducts(products);
  }, []);

  return (
    <main>
      <HeroSection />
      <FilterBar
        count={productCount}
        availableFilters={availableFilters}
        activeFilters={activeFilters}
        onFiltersChange={handleFiltersChange}
        allProducts={allProducts}
      />
      <ProductSelection
        onCountChange={handleCountChange}
        onFiltersAvailable={handleFiltersAvailable}
        onProductsLoaded={handleProductsLoaded}
        activeFilters={activeFilters}
      />
    </main>
  );
}

export default ProductsPage;